import React from 'react';

class ContactBlock extends React.Component {
  constructor (props) {
    super(props);
  }

  render () {
    const { contact, list } = this.props;
    const { name, street, street2, city, phone, emailLabel, email, link, linkLabel } = contact;
    return (
      <div className={`ContactBlock`}>
        {!name ? null : <h2 dangerouslySetInnerHTML={{ __html: name }} />}
        {(!street && !city) ? null : (
          <address>
            {!street ? null : street}
            {(!street || !street2) ? null : <br/>}
            {!street2 ? null : street2}
            {(!street || !city) ? null : <br />}
            {!city ? null : city}
          </address>
        )}
        {!phone ? null : <tel>{phone}</tel>}
        {!emailLabel ? null : <span>{emailLabel}:</span>}
        {!email ? null : <a href={'mailto:' + email}>{email}</a>}
        {!link ? null : linkLabel && <a href={link} target="_blank">{linkLabel}</a>}
      </div>
    );
  }
};

export default ContactBlock;



// WEBPACK FOOTER //
// ./client/Core/Components/ContactBlock.jsx